import React, { useState } from "react";
import {
  TextField,
  Button,
  Switch,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormLabel
} from "@mui/material";
import Grid from "@mui/material/Grid2"
import EmailIcon from '@mui/icons-material/Email';
import { Send } from "lucide-react"


const EmailModule = () => {
  const [status, setStatus] = useState(true);
  const [formValues, setFormValues] = useState({});

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleSwitch = () => {
    setStatus(!status);
  };

  const handleSubmit = () => {
  };

  const handleReset = () => {
    setFormValues({
      mailerName: "",
      host: "",
      driver: "",
      port: "",
      emailId: "",
      username: "",
      password: "",
      encryption: "",
    });
  };

  return (
    <div className="content">
       <Box >
        <Grid sx={{ p: 2, border: "1px solid #ddd", borderRadius: 2 ,width:"65%"}} >
          <Button variant="contained" startIcon={<EmailIcon />} color="success" sx={{mb:2}}> Test your email integration</Button>
          <Grid container spacing={4}>
          <Grid  size={9} >
          <TextField placeholder="Ex: BP@gmail.com" fullWidth  />
           </Grid>
             <Grid size={3}>
           <Button variant="contained" color="success" startIcon={<Send width="18px"/>} >
                 Send Email
            </Button>
           </Grid>
          </Grid>

        </Grid>
      <Box display="flex" alignItems="center" mb={2}>
        <Typography variant="h6">Mail Configuration Status</Typography>
        <Switch checked={status} onChange={handleSwitch} color="success"/>
      </Box>

       <Grid container spacing={2}>
        <Grid item size={6}>
        <FormLabel htmlFor="mailername" >
           Mailer Name
            </FormLabel>
          <TextField
            fullWidth
            id="mailername"
            name="mailerName"
            placeholder="enter the mailer name"
            value={formValues.mailerName}
            onChange={handleChange}
          />
        </Grid>

        <Grid item size={6} >
        <FormLabel htmlFor="host" >
          Host
            </FormLabel>
          <TextField
            fullWidth
            id="host"
            name="host"
            palceholder="Ex:smtp.gmail.com"
            value={formValues.host}
            onChange={handleChange}
          />
        </Grid>
        <Grid item size={6}>
        <FormLabel htmlFor="driver" sx={{mb:1}} >
              Driver
            </FormLabel>  
            <Select
            id="driver"
              name="driver"
              value={formValues.driver}
              onChange={handleChange}
              fullWidth
            >
              <MenuItem value="sendmail">Sendmail</MenuItem>
              <MenuItem value="smtp">SMTP</MenuItem>
            </Select>
          
        </Grid>

        <Grid item size={6} >
          <FormControl fullWidth>
          <FormLabel htmlFor="port" >
              Port
            </FormLabel>
           
            <TextField
            fullWidth
            id="port"
            name="port"
            type="number"
            value={formValues.port}
            onChange={handleChange}
          />
          </FormControl>
        </Grid>

        <Grid item size={6} >
        <FormLabel htmlFor="username" >
            Username
            </FormLabel>
         <TextField
            fullWidth
            id="username"
            name="username"
            placeholder="enter the username"
            value={formValues.username}
            onChange={handleChange}
          />
          
        </Grid>

        <Grid item size={6}>
        <FormLabel htmlFor="email" >
              Email ID
            </FormLabel>
          <TextField
            fullWidth
            name="email"
            id="email"
            placeholder="enter the email"
            value={formValues.emailId}
            onChange={handleChange}
          />
        </Grid>
        <Grid item size={6}>
         
          <FormControl fullWidth>
          <FormLabel htmlFor="encryption" >
            Encryption
            </FormLabel>            
            <Select
            id="encryption"
              name="encryption"
              value={formValues.encryption}
              onChange={handleChange}
            >
              <MenuItem value="tls">TLS</MenuItem>
              <MenuItem value="ssl">SSL</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item size={6} sx={{mt:1}}>
        <FormLabel htmlFor="password" >
          Password
            </FormLabel>
            <TextField
              variant="outlined"
            placeholder="Password"
            fullWidth
            name="password"
            type="password"
            value={formValues.password}
            onChange={handleChange}
          />
        </Grid>
      </Grid>

      <Box display="flex" justifyContent="flex-end" mt={3} spacing={3}>
        <Button variant="outlined" color="success" onClick={handleReset} sx={{mr:2}}>
          Reset
        </Button>
        <Button variant="contained" color="success" onClick={handleSubmit}>
          Save
        </Button>
      </Box> 

    </Box>
    </div>
   
  );
};

export default EmailModule;